import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import { type HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'
import { type MediaTypeEntity, type SortByEntity, type SortOrderEntity } from '../entities/media.entity'

export class GetMediaQuery extends GetNetworkQuery {
  constructor(
    private readonly fromDate: string,
    private readonly toDate: string,
    private readonly fromPrevious: string,
    private readonly toPrevious: string,
    private readonly sortBy: SortByEntity,
    private readonly sortOrder: SortOrderEntity,
    private readonly offset: number,
    private readonly limit: number,
    private readonly mediaType: MediaTypeEntity,
    private readonly organization: string
  ) {
    super(ApiEndpoint.EngagementMedia)
  }

  public get queryParameters(): HttpParameters {
    return {
      from_date: this.fromDate,
      to_date: this.toDate,
      from_previous: this.fromPrevious,
      to_previous: this.toPrevious,
      sort_by: this.sortBy,
      sort_order: this.sortOrder,
      offset: this.offset,
      limit: this.limit,
      media_type: this.mediaType,
      organization: this.organization
    }
  }
}
